import { RiskRes } from "@/models/risks.model"
import { PHAClient } from "@/utils/axios"

export const getRisk = async (): Promise<RiskRes> => {
  const response = await PHAClient.get(`/api/risk/all`)
  return response.data
}